<mat-toolbar class="p-0 mat-elevation-z1 primary-bg md-size-screen">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/fuse.svg" alt="logo">
                </div>
            </div>

            <div class="px-8 px-md-16">
                <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
            </div>

        </div>

        <div class="setting-section" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
            <div class="user-name">{{username}}</div>

            <div class="toolbar-separator"></div>

            <button mat-button [matMenuTriggerFor]="settingsMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon class="secondary-text">settings</mat-icon>
                </div>
            </button>

            <mat-menu #settingsMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item [routerLink]="'/ChangePassword'">
                    <mat-icon>lock</mat-icon>
                    <span>Cambiar contraseña</span>
                </button>
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Cerrar sesión</span>
                </button>

            </mat-menu>

        </div>

    </div>

</mat-toolbar>